module.exports = __webpack_public_path__ + "img/zoom_icon.7af1865b.png";